module.exports = __webpack_public_path__ + "static/media/people4.89d3e669.jpg";